module.exports = __webpack_public_path__ + "img/credible.30da7fd1.svg";